
import { OnInit } from '@angular/core';
import * as moment from 'moment/moment';

export abstract class PageBase {

  public numEmployees = ['1 a 10', '11 a 100', '100 a 250', '250 a 500', '500 a 1.000', 'Mais de 1.000'];

  public cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

  public cardValidate = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  public cardNumber = [/\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];

  public telephoneMask = [
    '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
  ];

  public cnpjMask: any = [
    /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/,
    '-', /\d/, /\d/
  ];
  public cpfMask = [
    /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/
  ];
  public phoneValidation = new RegExp(/^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/);
  public emailValidation = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

  public checkCPF(cpf: string): boolean {
    if (! cpf) { return false; }
    cpf = cpf.replace(/[^\d]+/g, '');

    if (cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999') {
            return false;
    }

    let add = 0;
    for (let i = 0; i < 9; i ++) {
        add += parseInt(cpf.charAt(i), 10) * (10 - i);
    }

    let rev = 11 - (add % 11);

    if (rev === 10 || rev === 11) {
        rev = 0;
    }

    if (rev !== parseInt(cpf.charAt(9), 10)) {
        return false;
    }

    add = 0;
    for (let i = 0; i < 10; i ++) {
        add += parseInt(cpf.charAt(i), 10) * (11 - i);
    }

    rev = 11 - (add % 11);

    if (rev === 10 || rev === 11) {
        rev = 0;
    }

    if (rev !== parseInt(cpf.charAt(10), 10)) {
        return false;
    }

    return true;
  }

  public checkCNPJ(cnpj: string): boolean {
    if (! cnpj) { return false; }
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14) { return false; }

    if (cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999') {
        return false;
    }

    let cnpjLength = cnpj.length - 2;
    let numberCnpj = cnpj.substring(0, cnpjLength);
    let digits = cnpj.substring(cnpjLength);
    let sum = 0;
    let pos = cnpjLength - 7;
    for (let i = cnpjLength; i >= 1; i--) {
      sum += parseInt(numberCnpj.charAt(cnpjLength - i), 10) * pos--;
      if (pos < 2) {
         pos = 9;
      }
    }
    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseFloat(digits.charAt(0))) {
        return false;
    }

    cnpjLength = cnpjLength + 1;
    numberCnpj = cnpj.substring(0, cnpjLength);
    sum = 0;
    pos = cnpjLength - 7;
    for (let i = cnpjLength; i >= 1; i--) {
      sum += parseInt(numberCnpj.charAt(cnpjLength - i), 10) * pos--;
      if (pos < 2) {
         pos = 9;
      }
    }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseFloat(digits.charAt(1))) {
       return false;
    }

    return true;
  }

  public removeMasks(cpf: string, cnpj?: string): string {
    if (cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');
        return cpf;
    }

    if (cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');
        return cnpj;
    }
  }

    public validateAddress(addressList: any[], isCompany: boolean, index?: number): boolean {
        let flag = true;
        if (index != null) {

            if (addressList.length === 0) {
                flag = false;
            } else {
                if (!addressList[index].nameUnit ||
                    !addressList[index].cep ||
                    !addressList[index].neighborhood ||
                    !addressList[index].county ||
                    !addressList[index].state ||
                    !addressList[index].street ||
                    !addressList[index].number) {
                        flag = false;
                    }

                if (isCompany && !addressList[index].num_employees) {
                    flag = false;
                }
            }
        } else {
            addressList.forEach((address) => {
                if (!address.nameUnit ||
                !address.cep ||
                !address.neighborhood ||
                !address.county ||
                !address.state ||
                !address.street ||
                !address.number) {
                    flag = false;
                }
                if (isCompany && !address.num_employees) {
                    flag = false;
                }
            });
        }
        return flag;
    }

    public checkAddressErros(addressList: any[]) {
        let addressErrosList = [];

        addressList.forEach((address, index) => {
            const { nameUnit, num_employees, cep, neighborhood, county, state, street, number } = address;
            addressErrosList.push({});

            addressErrosList[index].nameUnit = !!!nameUnit;
            addressErrosList[index].num_employees = !!!num_employees;
            addressErrosList[index].cep = !!!cep;
            addressErrosList[index].neighborhood = !!!neighborhood;
            addressErrosList[index].county = !!!county;
            addressErrosList[index].state = !!!state;
            addressErrosList[index].street = !!!street;
            addressErrosList[index].number = !!!number;

            if (!address.nameUnit || !address.cep || !address.neighborhood || !address.county || !address.state
                || !address.street || !address.number) {
                addressErrosList[index].error = true;
            }
        });
        return addressErrosList;
    }

    public CSVToArray(strData, strDelimiter): any {
        strDelimiter = (strDelimiter || ",");
        let objPattern = new RegExp((
        // Delimiters.
        "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
        // Quoted fields.
        "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
        // Standard fields.
        "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
        let arrData = [[]];
        let arrMatches = null;
        while (arrMatches = objPattern.exec(strData)) {
            let strMatchedDelimiter = arrMatches[1];
            if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
                arrData.push([]);
            }
            let strMatchedValue;
            if (arrMatches[2]) {
                strMatchedValue = arrMatches[2].replace(
                new RegExp("\"\"", "g"), "\"");
            } else {
                strMatchedValue = arrMatches[3];
            }
            arrData[arrData.length - 1].push(strMatchedValue);
        }
        return (arrData);
      }

      public CSV2JSON(csv, strDelimiter): any {
        let array = this.CSVToArray(csv, strDelimiter);
        let objArray = [];
        for (let i = 1; i < array.length; i++) {
            objArray[i - 1] = {};
            for (let k = 0; k < array[0].length && k < array[i].length; k++) {
                let key = array[0][k];
                objArray[i - 1][key] = array[i][k]
            }
        }

        let json = JSON.stringify(objArray);
        let str = json.replace(/},/g, "},\r\n");

        return str;
      }

      public checkEmail(email: string): boolean {
        if (!email) { return false; }
        return this.emailValidation.test(email);
      }

    public checkCardNumber(value){
        value = `${value}`.replace(/[^0-9]/g, "");
        if (/[^0-9-\s]+/.test(value)) return false;
        let nCheck = 0, nDigit = 0, bEven = false;
        value = value.replace(/\D/g, "");

        for (let n = value.length - 1; n >= 0; n--) {
            let cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);

            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }

            nCheck += nDigit;
            bEven = !bEven;
        }
        return (nCheck % 10) == 0;
    }

    checkDate(date: string, format: string){
        let checkDate = moment(date, format);
        return checkDate.isValid();
    }

    convertDate(date: string, format: string){
        return moment(date).format(format);
    }
    
    checkGreaterThanToday(date){
        return moment(date).isSameOrAfter(new Date, 'days');
    }
}
